export const createRange = (start: number, end: number): number[] => {
  return Array.from({ length: end - start + 1 }, (_, i) => i + start);
};

export const transpose = <T>(array: T[], offset: number): T[] => {
  const table = [...array];
  for (let i = 0; i < offset; i++) {
    const shifted = table.shift();
    if (shifted !== undefined) {
      table.push(shifted);
    }
  }
  return table;
};
